export default __webpack_public_path__ + "static/media/icon-fireplace.f51bf4c5.svg";